import { Edge, Node } from "@xyflow/react";

export enum MessageBotNodesEnum {
  ROOT = "RootNode",
  ACTION = "ActionNode",
  POPUP = "PopupNode",
}

export enum MessageBotEdgeTypesEnum {
  Dashed = "dashed-edge",
}

export type MessageBotNodeDataBase = {
  label: string;
};

export type MessageBotNodeDataRoot = MessageBotNodeDataBase & {};

export type MessageBotNodeDataPopup = MessageBotNodeDataBase & {
  url: string;
};

export type MessageBotNodeDataAction = MessageBotNodeDataBase & {
  message?: string;
};

export type MessageBotNodeData<T extends MessageBotNodesEnum> =
  MessageBotNodeDataBase &
    (T extends MessageBotNodesEnum.ROOT
      ? MessageBotNodeDataRoot
      : T extends MessageBotNodesEnum.POPUP
        ? MessageBotNodeDataPopup
        : MessageBotNodeDataAction);

export type MessageBotNode<
  T extends MessageBotNodesEnum = MessageBotNodesEnum,
> = Node<MessageBotNodeData<T>> & {
  generation: number;
  type: T;
  data: MessageBotNodeData<T>;
  parentId?: string | null;
  parent?: MessageBotNode<T> | null;
};

export type MessageBotEdge = Edge & {
  type: MessageBotEdgeTypesEnum;
  curvature?: number;
};

export type MessageBotNodeDataValues = {
  [k in MessageBotNodesEnum]: {
    [key in keyof MessageBotNodeData<k>]: {
      messageId: string;
      type: string;
    };
  };
};

export type MessageBotNodeInfos = Record<
  MessageBotNodesEnum,
  {
    size: {
      width: number;
      height: number;
    };
    edges?: Partial<
      Record<
        MessageBotNodesEnum,
        {
          type: MessageBotEdgeTypesEnum;
          label: string;
        }
      >
    >;
  }
>;
